












import { defineComponent, PropType, ref } from "@vue/composition-api";
import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { InputSubscriptionLevelCreate } from "@scrile/api-provider/dist/api/SubscriptionLevelProvider";
import { $t } from "@/lib/i18nHelpers";
import { FormValues } from "@/types";
import BaseButton from "@/components/BaseButton";
import ModalView from "@/components/ModalView";
import PageTitle from "@/components/PageTitle";
import PriceLevelEditForm from "./PriceLevelEditForm.vue";

export default defineComponent({
  name: "CreateLevelView",
  components: { PriceLevelEditForm, ModalView, PageTitle, BaseButton },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, required: true },
    paymentPackages: { type: Array as PropType<PaymentPackage[]>, required: true },
    userId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const values = ref<FormValues>({
      pricePackageId: props.paymentPackages[0]?.id ?? "0",
      description: "",
    });

    const pricePackageIdHint = $t(
      "Price for new subscribers. Current subscribers will be unsubscribed at the end of the month"
    );

    const create = () => {
      const data: InputSubscriptionLevelCreate = {
        pricePackageId: values.value.pricePackageId,
        description: values.value.description || "",
        userId: props.userId,
      };
      emit("create", data);
    };

    return {
      values,
      pricePackageIdHint,
      create,
    };
  },
});
